import * as React from 'react';

export interface ResizeWrapperState {
  windowWidth: number;
} 

export class ResizeWrapper extends React.Component<React.PropsWithChildren, ResizeWrapperState> {

  constructor(props: {}) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth
    };
  }

  public componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  public componentWillUnmount(){
      window.removeEventListener('resize', this.handleResize);
  }

  private handleResize = () => {
    this.setState({
      windowWidth: window.innerWidth
    });
  };

  public render() { 
    return React.cloneElement(React.Children.only(this.props.children as any), { width: this.state.windowWidth });
  }
}
